import request from '@/http/request'
import {
  getPlanCoursePublish,
  publishStudentScore,
  getStudentScoreList,
  getOtsUrl,
  getExamCheckState,
  changeExamCheckState,
  exportStudentScore,
  changeCourseScoreSet,
  getCourseScoreSet,
  getPageList,
  scoreImport,
  getEnableScoreImport,
  importCheckStateFile,
  getCheckStateTemplate,
  getTrialScoreLinePlanList,
  getCourseList,
  getTrialScoreLineList,
  getPlan,
  getExamNumByCourse,
  getSubCourseList,
  getSubCourseStudentScoreList,
  exportSubCourseStudentScoreList,
  getStudentSubCourseList
} from '@/http/api'

export const getStudentSubCourseListAPI = (data) => {
  return request({
    url: getStudentSubCourseList,
    data,
  })
}

export const exportSubCourseStudentScoreListAPI = (data) => {
  return request({
    url: exportSubCourseStudentScoreList,
    data,
  })
}

export const getSubCourseStudentScoreListAPI = (data) => {
  return request({
    url: getSubCourseStudentScoreList,
    data,
  })
}

export const getSubCourseListAPI = (data) => {
  return request({
    url: getSubCourseList,
    data,
  })
}

export const getExamNumByCourseAPI = (data) => {
  return request({
    url: getExamNumByCourse,
    data,
  })
}

export const getPlanApi = (data) => {
  return request({
    url: getPlan,
    data,
  })
}

export const getTrialScoreLineListApi = (data) => {
  return request({
    url: getTrialScoreLineList,
    data,
  })
}

export const getCourseListApi = (data) => {
  return request({
    url: getCourseList,
    data,
  })
}

export const getTrialScoreLinePlanListApi = (data) => {
  return request({
    url: getTrialScoreLinePlanList,
    data,
  })
}

export const changeCourseScoreSets = (data) => {
  return request({
    url: changeCourseScoreSet,
    data,
  })
}
export const getCourseScore = (data) => {
  return request({
    url: getCourseScoreSet,
    data,
  })
}
export const getPlanCoursePublishFn = (data) => {
  return request({
    url: getPlanCoursePublish,
    data,
  })
}

export const publishStudentScoreFn = (data) => {
  return request({
    url: publishStudentScore,
    data,
  })
}

export const getPageListFn = (data) => {
  return request({
    url: getPageList,
    data,
  })
}
export const getStudentScoreListFn = (data) => {
  return request({
    url: getStudentScoreList,
    data,
  })
}
export const getOtsUrlFn = (data) => {
  return request({
    url: getOtsUrl,
    data,
  })
}

export const getExamCheckStateFn = () => {
  return request({
    url: getExamCheckState,
  })
}

export const changeExamCheckStateFn = (data) => {
  return request({
    url: changeExamCheckState,
    data,
  })
}

export const exportStudentScoreFn = (data) => {
  return request({
    url: exportStudentScore,
    data,
  })
}
export const dateAuditState = (data) => {
  return request({
    url: updateAuditState,
    data,
  })

}
export const scoreImportecxel = (data) => {
  return request({
    url: scoreImport,
    isUpload: true,
    data,
  })

}
export const getEnableScoreImportpland = (data) => {
  return request({
    url: getEnableScoreImport,
    data,
  })

}
export const importCheckStateFileexcel = (data) => {
  return request({
    url: importCheckStateFile,
    isUpload: true,
    data,
  })

}
export const getCheckStateTemplateexcel = (data) => {
  return request({
    url: getCheckStateTemplate,
    isUpload: true,
    data,
  })
}